<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="list"
      selected-product="cso"
      :product-options="productOptions"
      :filter-names="filterNames"
      search-label="search"
      @filterOption="onFiltersChange"
    >
      <template v-slot:id="{ item }">
        <div class="d-flex align-center">
          <status-badge :status="item.connectivity_status" />
          <span>
            {{ item.charge_point_id }}
            {{ item.connector_id ? `/${item.connector_id}` : "" }}
          </span>
        </div>
      </template>
      <template v-slot:location_name="{ item }">
        <div>
          <div>{{ item?.location_display_name }}</div>
          <div>{{ item?.location_name }}</div>
        </div>
      </template>
      <template v-slot:power="{ item }">
        <span>{{ item.power || 0 }} kW</span>
      </template>
      <template v-slot:power_type="{ item }">
        <span class="text-uppercase">{{ item.power_type }}</span>
      </template>
      <template v-slot:connector_state="{ item }">
        <span class="text-capitalize">
          {{
            item.connectivity_status == "offline"
              ? "offline"
              : item.connector_state
          }}
        </span>
      </template>

      <template v-slot:updated_at="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
            >
              {{ item?.updated_at }}
              <span class="mdi ml-2 mdi-information-variant-circle-outline" />
            </span>
          </template>
          <span>
            This show the last connector status update event, Revecied from
            charger
          </span>
        </v-tooltip>
      </template>
      <template v-slot:remote_operations="{ item }">
        <!-- item.connectivity_status == 'online'     -->
        <span v-if="item.connectivity_status == 'online'">
          <v-btn
            v-if="['Available', 'Preparing'].includes(item.connector_state)"
            color="primary"
            small
            @click="editItem(item)"
          >
            {{ $t("remote_start_transaction ") }}
          </v-btn>
          <v-btn
            v-else-if="['Charging'].includes(item.connector_state)"
            color="danger"
            small
            @click="stopTrasction(item)"
          >
            {{ $t("remote_stop_transaction ") }}
          </v-btn>
        </span>
      </template>

      <template #addFilters>
        <v-card>
          <v-select
            v-model="connector_state"
            filled
            dense
            clearable
            :items="stateList"
            item-value="id"
            item-text="name"
            :label="$t('connector_state')"
            @change="fetchData"
          />
        </v-card>
      </template>
      <template #moreFilters>
        <div>
          <refresh-button
            :is-loading="isLoading"
            @reload="fetchData"
          />
        </div>
      </template>
      <template #actionModals>
        <start-transtions
          v-if="editModal"
          :is-visible-dialog="editModal"
          :toggle-edit="toggleEditModal"
          :customer-data="selectedRow"
          @change="fetchData"
        />
      </template>
      <!-- Action Dialog -->
      <!-- <v-dialog v-model="dialog" max-width="800px">
        <start-transtions :customer-data="selectedRow"/>
      </v-dialog> -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";

import { mapGetters } from "vuex";
// import { debounce } from "lodash";
export default {
  components: {
    StartTranstions: () => import("./utils/StartTranstions.vue"),
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    refreshButton: () =>
      import("../../../../components/base/RefreshButton.vue"),
    StatusBadge: () => import("@/components/base/Status-Badge.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      customerAdd: true,
      tableView: false,
      dialog: false,
      searchQuery: "",
      selectedCustomer: null,
      customerData: [],
      headers: [
        { text: "", value: "checkbox", align: "start" },
        { text: "Customer Name", value: "name" },
        { text: "Phone", value: "phone" },
        { text: "Email", value: "email" },
        { text: "Vehicle", value: "vehicle" },
        { text: "Booking Time", value: "bookingTime" },
      ],

      filters: {},
      subFilters: {},
      connector_state: "",
      cityName: "",
      location: "",
      productOptions: [
        { id: "oem", value: "OEM" },
        { id: "cso", value: "CSO" },
      ],
      stateList: [
        {
          id: "Available",
          name: "Available",
        },
        {
          id: "Unavailable",
          name: "Unavailable",
        },
        {
          id: "Charging",
          name: "Charging",
        },
        {
          id: "Preparing",
          name: "Preparing",
        },
        {
          id: "Finishing",
          name: "Finishing",
        },
        {
          id: "Accepted",
          name: "Accepted",
        },
        {
          id: "Faulted",
          name: "Faulted",
        },
        {
          id: "Reserved",
          name: "Reserved",
        },
        {
          id: "Suspended EV",
          name: "Suspended EV",
        },
        {
          id: "Suspended EVSE",
          name: "Suspended EVSE",
        },
      ],
      isMounted: false,
      itemData: {},
      interval: null,
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "csmsChargeStations/getLoading",
      meta: "csmsChargeStations/getConnectorMeta",
      list: "csmsChargeStations/getConnectorlist",
      locationsList: "csmsChargeStations/getLocation",
    }),
    _headers() {
      const headers = [
        {
          text: this.$t("connector_id"),
          align: "left",
          sortable: true,
          value: "id",
        },

        {
          text: this.$t("tenant_name"),
          align: "left",
          sortable: false,
          value: "tenant_name",
        },
        {
          text: this.$t("location"),
          align: "left",
          sortable: false,
          value: "location_name",
        },
        // {
        //   text: this.$t("charge_stations"),
        //   align: "left",
        //   sortable: false,
        //   value: "charge_station",
        // },
        {
          text: this.$t("connector_type"),
          align: "left",
          sortable: false,
          value: "connector_type",
        },
        {
          text: this.$t("connector_format"),
          align: "left",
          sortable: false,
          value: "connector_format",
        },
        {
          text: `${this.$t("capacity")} (kW)`,
          align: "center",
          sortable: false,
          value: "power",
        },
        {
          text: this.$t("power_type"),
          align: "left",
          sortable: false,
          value: "power_type",
        },
        // {
        //   text: this.$t("power"),
        //   align: "left",
        //   sortable: false,
        //   value: "power",
        // },
        {
          text: this.$t("connector_state"),
          align: "left",
          sortable: false,
          value: "connector_state",
        },
        // {
        //   text: this.$t("unavailability_reason"),
        //   align: "left",
        //   sortable: false,
        //   value: "unavailability_reason",
        // },
        {
          text: this.$t("last_updated_at"),
          align: "left",
          sortable: true,
          value: "updated_at",
        },
        ...(this.$admin.hasAccessTo("remote.actions")
          ? [
              {
                text: this.$t("remote_operations"),
                align: "left",
                sortable: false,
                value: "remote_operations",
              },
            ]
          : []),
      ];
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },
    transactionHeader() {
      const headers = [
        { text: "", value: "checkbox", align: "start" },
        { text: "Customer Name", value: "name" },
        { text: "Phone", value: "phone" },
        { text: "Email", value: "email" },
        { text: "Vehicle", value: "vehicle" },
        { text: "Booking Time", value: "bookingTime" },
      ];
      return headers;
    },
    locations() {
      return (
        this.locationsList.filter((r) => r.city_name === this.cityName) || []
      );
    },
    filterNames() {
      return ["location_city", "locations", "charge_point"];
    },
  },
  watch: {
    "options.tenant_id": {
      handler: function () {},
    },
    options() {
      this.fetchData();
    },
  },
  async mounted() {
    if (this.$route?.query?.connector_state) {
      this.connector_state = this.$route.query.connector_state;
    }
  },
  beforeDestroy() {
    clearTimeout(this.interval);

    const paramsset = { ...this.options };
    paramsset.connector_state = this.connector_state;
    const params = {
      name: "charge_connectors",
      filters: paramsset,
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {
    openDialog(val) {
      this.dialog = true;
      this.customerAdd = false;
      this.tableView = false;
      this.searchQuery = "";
      this.customerData = []; // Reset data
      this.selectedCustomer = null; // Clear selection
      this.itemData = val; // Clear selection
    },
    async stopTrasction(item) {
      let params = {};
      params.action = "remote-transaction-stop";
      params.charge_point_id = item.charge_point_id;
      params.connector_id = item.connector_id;
      let code = "alerts/success";
      this.$store.dispatch("csmsChargeStations/setLoadingValue", true);
      await this.$store
        .dispatch("csmsChargeStations/ocppRemoteAction", params)
        .then((response) => {
          if (response.body.status == "Rejected") {
            code = "alerts/error";
          }
          this.$store.dispatch(code, this.$t(response.body.status));
          setTimeout(() => {
            this.fetchData();
          }, 5000);
          // this.fetchData();
        })
        .catch((error) => {
          this.$store.dispatch("alerts/error", error.response?.data?.message);
          this.$store.dispatch("csmsChargeStations/setLoadingValue", false);
        });
    },
    async fetchData() {
      clearTimeout(this.interval);
      const params = { ...this.options };
      params.connector_state = this.connector_state;
      await this.$store
        .dispatch("csmsChargeStations/connectorlist", params)
        .then(() => {
          if (this.options.page > (this.meta?.lastPage || 1)) {
            this.options.page = 1;
          }
        });

      this.interval = setTimeout(() => {
        this.fetchData();
      }, 30000);
    },
    fetchStatus(item) {
      if (["Available"].includes(item.connector_state)) {
        return "active";
      } else if (
        ["Preparing", "Charging", "Finishing"].includes(item.connector_state)
      ) {
        return "inactive";
      } else {
        return "offline";
      }
    },

    //
    startAction() {
      // Start Action
    },
    closeDialog() {
      this.dialog = false;
      this.customerAdd = false;
      this.tableView = false;
      this.searchQuery = "";
      this.customerData = [];
      this.selectedCustomer = null;
      this.itemData = null; // Clear selection
    },
  },
};
</script>
